import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFamilyinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "#000",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(41.78 7)",
				children: [
					/* @__PURE__ */ _jsx("path", { d: "M.8422 21.6136l5.0459-6.9048a4 4 0 0 1 3.2295-1.64H16.24c.7276 0 1.6958.6994 1.7876 1.6178l2.533 16.3478H4.3917l1.7966-10.7793" }),
					/* @__PURE__ */ _jsx("circle", {
						cx: 12.476,
						cy: 4.984,
						r: 4.491
					}),
					/* @__PURE__ */ _jsx("path", { d: "M10.7855 49h3.3813c1.0657 0 1.9443-.8357 1.9975-1.9001l.8033-16.0655H7.9848L8.788 47.1C8.8413 48.1643 9.7198 49 10.7855 49z" })
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(1.22 7.254)",
				children: [/* @__PURE__ */ _jsx("path", { d: "M17.2207 20.6768l5.6102 13.9742H0l8.2703-20.017a2 2 0 0 1 1.8485-1.2363h4.41c.5397 0 1.1559.4121 1.8485 1.2363l6.2098 6.7064M10.4435 48.8198h1.9439a2 2 0 0 0 1.9663-1.6344L16.684 34.651H6.1468l2.3304 12.5344a2 2 0 0 0 1.9663 1.6344z" }), /* @__PURE__ */ _jsx("circle", {
					cx: 12,
					cy: 5.238,
					r: 4.491
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(25.78 23)",
				children: [/* @__PURE__ */ _jsx("circle", {
					cx: 7.476,
					cy: 4.441,
					r: 3.611,
					transform: "matrix(-1 0 0 1 14.952 0)"
				}), /* @__PURE__ */ _jsx("path", { d: "M.9438 8.7177c2.4333 2.76 4.0202 4.1402 4.7607 4.1402h4.5758c.4638 0 3.7275-4.1402 3.7275-4.1402m-1.928 6.6746c.2122 1.3696.5306 6.1798.955 8.919H2.7268l.825-8.4825M7.4667 33.294h.8283c1.0552 0 1.9288-.8197 1.996-1.8727l.4532-7.11H5.0174l.4533 7.11c.0671 1.053.9408 1.8727 1.996 1.8727z" })]
			})
		]
	})
});
export default SvgFamilyinline;
